import { render, staticRenderFns } from "./DataDokumen.vue?vue&type=template&id=255512ad&"
import script from "./DataDokumen.vue?vue&type=script&lang=js&"
export * from "./DataDokumen.vue?vue&type=script&lang=js&"
import style0 from "./DataDokumen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports